<template>
    <v-chip v-if="ticket.status === FreshDeskTicketStatusesV1.Open" size="small" color="amber-darken-3">OPEN</v-chip>
    <v-chip v-else-if="ticket.status === FreshDeskTicketStatusesV1.Pending" size="small" color="amber-darken-3">PENDING</v-chip>
    <v-chip v-else-if="ticket.status === FreshDeskTicketStatusesV1.Closed" size="small" color="light-blue-darken-3">CLOSED</v-chip>
    <v-chip v-else-if="ticket.status === FreshDeskTicketStatusesV1.Resolved" size="small" color="light-blue-darken-3">RESOLVED</v-chip>
    <v-chip v-else color="gray-darken-1" size="small">{{ ticket.status }}</v-chip>
</template>

<script setup lang="ts">
import { type AccountTicketV1, FreshDeskTicketStatusesV1 } from '@geckoal/gecko-api-client'
import { type PropType } from 'vue'

defineProps({
    ticket: {
        type: Object as PropType<AccountTicketV1>,
        required: true
    }
})
</script>
